export default __webpack_public_path__ + "static/media/icon-20.52d8eeb1.png";